/* eslint-disable no-console */
import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType, SubQuestionID } from '../types'
import {
  DistributeQuestionModelTypes,
  DistributeResponse,
  DistributeSubmitResponse,
  IDistributeQuestionModelState,
  IDistributeResponseValidation
} from './types'

const DistributeQuestionModel: IQuestionModelConstructor<DistributeQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<DistributeQuestionModelTypes, IDistributeQuestionModelState>({
    questionType: QuestionType.DISTRIBUTE,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IDistributeQuestionModelState) {
  const data = response.data.reduce((acc: DistributeSubmitResponse, item) => {
    const it: ArrayElementType<DistributeSubmitResponse> = { v: item.v || 0, id: item.id }
    if (!item.hidden) acc.push(it)
    return acc
  }, [])
  return data
}

function initState(state: IDistributeQuestionModelState): IDistributeQuestionModelState {
  state.response = {
    data: state.questionSchema.matrix_batches.map<DistributeResponse['data'][number]>(batch => {
      return { id: batch.id, v: null }
    }),
    valid: false
  }
  return state
}

function validateResponse({ response, questionSchema }: IDistributeQuestionModelState): IDistributeResponseValidation {
  if (!response.data.filter(b => !b.hidden).length)
    return {
      valid: true
    }

  const invalidBatches: SubQuestionID[] = []
  // if (questionSchema.scale_type)

  response.data.forEach(item => {
    if (null === item.v && !item.hidden) invalidBatches.push(item.id)
  })
  return {
    valid: !questionSchema.scale_type
      ? Math.round(questionSchema.degree * 100) ==
        Math.round(response.data.reduce((acc, item) => acc + item.v * 100, 0))
      : !response.data.some(item => null === item.v && !item.hidden),
    invalidBatches: invalidBatches
  }
}

export default DistributeQuestionModel
